export default __webpack_public_path__ + "static/media/Underlay.ba3e9327.png";